import { Injectable } from '@angular/core';
import { SETTINGS } from '../config/common.settings';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class DestinationService {
  destinations: any = [];
  onDestinationsChange: Subject<any> = new BehaviorSubject([]);

  pagedDestinations: any = {};
  onPagedDestinationsChange: Subject<any> = new BehaviorSubject({});

  destination: any = {};
  onDestinationChange: Subject<any> = new BehaviorSubject({});

  constructor(private http: HttpClient) {}

  getAllDestinations(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(`${SETTINGS.BASE_API}/destinations/get-all`).subscribe({
        next: (response: any) => {
          this.destinations = response;
          this.onDestinationsChange.next(this.destinations);
          resolve(this.destinations);
        },
        error: (error: any) => {
          reject(error);
        },
      });
    });
  }

  getPagedDestinations(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/destinations/get-paged`, payload)
        .subscribe({
          next: (response: any) => {
            this.pagedDestinations = response[0];
            this.onPagedDestinationsChange.next(this.pagedDestinations);
            resolve(this.pagedDestinations);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  getOneDestination(id: string): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!id) {
        this.onDestinationChange.next({});
        resolve({});
      } else {
        this.http.get(`${SETTINGS.BASE_API}/destinations/get/${id}`).subscribe({
          next: (response: any) => {
            this.destination = response;
            this.onDestinationChange.next(this.destination);
            resolve(this.destination);
          },
          error: (error: any) => {
            reject(error);
          },
        });
      }
    });
  }

  createDestination(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/destinations/create`, payload)
        .subscribe({
          next: (response: any) => {
            this.destination = response;
            this.onDestinationChange.next(this.destination);
            resolve(this.destination);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  createDestinationModel(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/destinations/iti/create`, payload)
        .subscribe({
          next: (response: any) => {
            this.destination = response;
            this.onDestinationChange.next(this.destination);
            resolve(this.destination);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  updateDestination(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .put(`${SETTINGS.BASE_API}/destinations/update`, payload)
        .subscribe({
          next: (response: any) => {
            this.destination = response;
            this.onDestinationChange.next(this.destination);
            resolve(this.destination);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  updateDestinationItin(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .put(`${SETTINGS.BASE_API}/destinations/update/itin`, payload)
        .subscribe({
          next: (response: any) => {
            this.destination = response;
            resolve(this.destination);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  getDestinationByName(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/destinations/get-destination-by-name`, payload)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }


}
